import React from 'react';
import '../style/infoComponent.css'
import infoIcon from '../info.svg';
const InfoLabel = (props) => {
    return (
        <div className="infoComponent-wrapper">
            <img
                className="solicitor-form-input-info solicitor-form-info-input-element"
                src={infoIcon}
                onMouseOver={() => props.onMouseOverHandler(props.Name)}
                onMouseLeave={() =>  props.onMouseOverHandler(props.Name)}/>
            {
                props.infoState?
                    <div className="infoComponent-box infoComponent-box-size" style={{height: 'auto'}}>
                        <div className="infoComponent-wrapper-arrow_box-text">
                            {props.Value}
                        </div>
                    </div>
                    :
                    null
            }
        </div>
    )
};

export default InfoLabel;